/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_SearchingInputs */

const en_messages_searching = /** @type {(inputs: Messages_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching…`)
};

const he_messages_searching = /** @type {(inputs: Messages_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחפש…`)
};

/**
* | output |
* | --- |
* | "Searching…" |
*
* @param {Messages_SearchingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_searching = /** @type {((inputs?: Messages_SearchingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_SearchingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_searching(inputs)
	return he_messages_searching(inputs)
});